<template>
<div class="page-layout">
  <div class="page-content">
    <ErrorBox />
  </div>
</div>
</template>

<script>
import ErrorBox from '../ErrorBox/ErrorBox'
export default {
  name: 'ErrorRedirect',
  // mounted () {
  //  this.$router.push({ path: '/error' });
  // }
  components: {
    ErrorBox
  }
}
</script>

<style lang="scss" scoped>
.page-layout {
  background: map-deep-get($colors, 'white-off', 'base');
  min-height: 100vh;
  margin: 0 auto;
  .page-content {
    margin: 0 auto;
    padding-bottom: 1rem;
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      max-width: 720px;
    }
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      max-width: 1170px;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      margin: 0 15px;
    }
  }
}
</style>